export default {
  from: 'from',
  select: 'Select',
  deal: 'deal',
  deals: 'deals',
  total: 'total',
  total_fr: '',
  pp: 'pp',
}
